import { StoreType, StoreTypeVerticals } from 'models/store-type';
import { AnyAction, Reducer } from 'redux';

import { RedButtonCity } from './redbutton.actions';
import {
  LOAD_REDBUTTON_CITIES,
  LOAD_STORE_TYPES,
  SAVE_CHANGES_REDBUTTON,
  SET_CITY,
  SET_LOADING_REDBUTTON,
  SET_VERTICAL,
  SWITCH_STORE_TYPES,
  TOGGLE_ALL
} from './redbutton.types';

export interface RedButtonState {
  allEnabled: boolean;
  loading: boolean;
  stVerticals: StoreTypeVerticals;
  changes: StoreType[];
  vertical?: string;
  cities: RedButtonCity[];
  selectedCity?: RedButtonCity;
  loadingCities?: boolean;
}

const initialState: RedButtonState = {
  allEnabled: false,
  loading: false,
  stVerticals: {},
  changes: [],
  cities: []
};

const reducer: Reducer<RedButtonState> = (
  state: RedButtonState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case SAVE_CHANGES_REDBUTTON:
    case SET_LOADING_REDBUTTON:
    case TOGGLE_ALL:
    case LOAD_STORE_TYPES:
    case SWITCH_STORE_TYPES:
    case SET_VERTICAL:
    case LOAD_REDBUTTON_CITIES:
    case SET_CITY:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
